import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IMap } from '@nimbus-library/features/shared/models/interfaces';
import { BaseHttpService } from '@nimbus-library/features/shared/services/base-http/base-http.service';
import { GlobalApiRoutes } from '@nimbus-global/features/shared/services/api/global.api-routes.const';
import { FeatureReadModel } from '@nimbus-global/features/feature-flipping/feature.model';
import { Feature } from './feature.enum';
import { TenantFeatureFlagModel } from './tenant-feature-flag.model';

@Injectable({ providedIn: 'root' })
export class FeatureFlippingApiClient {
  public constructor(private readonly httpService: BaseHttpService) {}

  public get(): Observable<FeatureReadModel[]> {
    return this.httpService.get(GlobalApiRoutes.FeatureFlipper.get());
  }

  public areEnabled(features: Feature[]): Observable<IMap<boolean>> {
    return this.httpService.post('feature-flipping/v1/Feature', features).pipe(
      map((areEnabled: boolean[]) => {
        const result: IMap<boolean> = {};
        features.forEach((value, i) => (result[value] = areEnabled[i]));
        return result;
      }),
    );
  }

  public isEnabledInFeatureManagement(tenantId: string, feature: Feature): Observable<boolean> {
    return this.httpService.get(`feature-flipping/v1/featureManagement/${tenantId}/${feature}`);
  }

  /** Returns the subset of the supplied tenants for which the feature is enabled, in one request. */
  public getTenantsWithFeatureEnabled(feature: Feature, tenantIds: string[]): Observable<string[]> {
    return this.httpService.post(`feature-flipping/v1/featureManagement/${feature}/enabled-for-tenants`, tenantIds);
  }

  public getTenantFeatureFlags(tenantId: string): Observable<TenantFeatureFlagModel[]> {
    return this.httpService.get(`feature-flipping/v1/featureManagement/${tenantId}/feature-flags`);
  }
}
